import {
  GENDERS_GET,
  GENDERS_RECEIVE
} from '../actionTypes/genders';


export function getGenders() {
  return (dispatch, getState) => {
    if (!getState().genders.fetched) {
      dispatch({
        type: GENDERS_GET
      });

      fetch('https://planyourvisit-user.gateway.apps.blackpulp.com/api/v1/genders')
        .then(response => response.json())
        .then(response => {
          dispatch({
            type: GENDERS_RECEIVE,
            genders: response.data
          });
        });
    }
  };
}


// WEBPACK FOOTER //
// ./src/actions/genders.js